import React from 'react';
import { Button } from '../ui/button';

const AddressForm = ({
  newAddress,
  setNewAddress,
  addressErrors,
  handleSaveAddress,
  isSavingAddress,
  setShowAddressForm,
}) => {
  return (
    <div>
      <h4 className="font-medium text-gray-800 mb-4">Add Delivery Address</h4>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Full Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={newAddress.recipient}
            onChange={(e) =>
              setNewAddress({ ...newAddress, recipient: e.target.value })
            }
            className={`w-full px-3 py-2 border ${
              addressErrors.recipient ? 'border-red-500' : 'border-gray-300'
            } rounded-md`}
            placeholder="Enter recipient name"
          />
          {addressErrors.recipient && (
            <p className="text-red-500 text-sm mt-1">
              {addressErrors.recipient}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Address Line 1 <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={newAddress.line1}
            onChange={(e) =>
              setNewAddress({ ...newAddress, line1: e.target.value })
            }
            className={`w-full px-3 py-2 border ${
              addressErrors.line1 ? 'border-red-500' : 'border-gray-300'
            } rounded-md`}
            placeholder="Street address, house number"
          />
          {addressErrors.line1 && (
            <p className="text-red-500 text-sm mt-1">{addressErrors.line1}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Address Line 2
          </label>
          <input
            type="text"
            value={newAddress.line2}
            onChange={(e) =>
              setNewAddress({ ...newAddress, line2: e.target.value })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Apartment, floor, landmark (optional)"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              City <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={newAddress.city}
              onChange={(e) =>
                setNewAddress({ ...newAddress, city: e.target.value })
              }
              className={`w-full px-3 py-2 border ${
                addressErrors.city ? 'border-red-500' : 'border-gray-300'
              } rounded-md`}
              placeholder="City"
            />
            {addressErrors.city && (
              <p className="text-red-500 text-sm mt-1">{addressErrors.city}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              State <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={newAddress.state}
              onChange={(e) =>
                setNewAddress({ ...newAddress, state: e.target.value })
              }
              className={`w-full px-3 py-2 border ${
                addressErrors.state ? 'border-red-500' : 'border-gray-300'
              } rounded-md`}
              placeholder="State"
            />
            {addressErrors.state && (
              <p className="text-red-500 text-sm mt-1">{addressErrors.state}</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={newAddress.postal_code}
              onChange={(e) =>
                setNewAddress({ ...newAddress, postal_code: e.target.value })
              }
              className={`w-full px-3 py-2 border ${
                addressErrors.postal_code ? 'border-red-500' : 'border-gray-300'
              } rounded-md`}
              placeholder="Postal code"
            />
            {addressErrors.postal_code && (
              <p className="text-red-500 text-sm mt-1">
                {addressErrors.postal_code}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Country <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={newAddress.country}
              onChange={(e) =>
                setNewAddress({ ...newAddress, country: e.target.value })
              }
              className={`w-full px-3 py-2 border ${
                addressErrors.country ? 'border-red-500' : 'border-gray-300'
              } rounded-md`}
              placeholder="Country"
            />
            {addressErrors.country && (
              <p className="text-red-500 text-sm mt-1">
                {addressErrors.country}
              </p>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone Number <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            value={newAddress.phone}
            onChange={(e) =>
              setNewAddress({ ...newAddress, phone: e.target.value })
            }
            className={`w-full px-3 py-2 border ${
              addressErrors.phone ? 'border-red-500' : 'border-gray-300'
            } rounded-md`}
            placeholder="Phone number"
          />
          {addressErrors.phone && (
            <p className="text-red-500 text-sm mt-1">{addressErrors.phone}</p>
          )}
        </div>

        <div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="is_default"
              checked={newAddress.is_default}
              onChange={(e) =>
                setNewAddress({ ...newAddress, is_default: e.target.checked })
              }
              className="h-4 w-4 text-primary border-gray-300 rounded"
            />
            <label
              htmlFor="is_default"
              className="ml-2 block text-sm text-gray-700"
            >
              Set as default address
            </label>
          </div>
          <p className="text-xs text-gray-500 mt-1 ml-6">
            Default address will be selected automatically for all future
            orders. You can only have one default address.
          </p>
        </div>

        <div className="flex space-x-3 mt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => setShowAddressForm(false)}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleSaveAddress}
            className="flex-1"
            disabled={isSavingAddress}
          >
            {isSavingAddress ? 'Saving...' : 'Save Address'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddressForm;
